import React, { useRef, useEffect, useState } from "react";
import Switch from "@material-ui/core/Switch";
import ChevronRight from "_shared/images/icons/chevron-right-thin-dark.svg";

const AdminModal = ({
  openAdminModal,
  setOpenAdminModal,
  user,
  adminToggleIconRef,
  adminMode,
  setAdminMode,
  isAdminDepartment,
}) => {
  const [toggleOn, setToggleOn] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        adminToggleIconRef.current &&
        !adminToggleIconRef.current.contains(event.target)
      ) {
        // Only close if clicked outside BOTH modal and toggle button
        setOpenAdminModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openAdminModal]);

  return (
    <div
      ref={modalRef}
      className="z-1 absolute right-[3%] top-[110%] flex h-[156px] w-[276px] items-center justify-center rounded-lg bg-black bg-white shadow-[0_4px_4px_0_rgba(0,0,0,0.25)]"
    >
      <div className="w-[88%]">
        <div className="flex items-center">
          <div className="flex h-[39px] w-[39px] flex-shrink-0 items-center justify-center rounded-full bg-primary text-white">
            {`${user.firstName[0]}${user.lastName[0]}`}
          </div>
          <div className="pl-5">
            <p className="pb-1 text-typography-100">{`${user.firstName} ${user.lastName}`}</p>
            <p className="break-all font-[11px] text-typography-70">
              {user.email.toLowerCase()}
            </p>
          </div>
        </div>

        {isAdminDepartment && (
          <div className="flex flex-col pt-3 [&_p]:text-[14px] [&_p]:text-typography-100">
            <div className="flex items-center justify-between">
              <p>Admin Mode</p>
              <Switch
                checked={adminMode}
                size="small"
                onChange={() => {
                  setAdminMode(!adminMode);
                }}
                edge="end"
                color="primary"
              />
            </div>
            {/* feature not yet available */}
            {/* <div className="flex justify-between pt-[10px]">
            <p>View As</p>
            <img className="h-[14px] w-[14px]" src={ChevronRight} />
          </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminModal;
